import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import { registerLivechatHost, type LivechatHost } from './host'

const List = lazy(() => import('./components/List'))
const Detail = lazy(() => import('./components/Detail'))
const Analytics = lazy(() => import('./components/Analytics'))

const LivechatModule: RouteObject = {
    path: 'livechat',
    children: [
        {
            path: '',
            element: <List />,
        },
        {
            path: 'analytics',
            element: <Analytics />,
        },
        {
            path: ':roomId',
            element: <Detail />,
        },
    ],
}

/**
 * The Livechat route, for the host to mount (it adds the errorElement).
 *
 * This is the only way to get it, and it takes the host: so a host cannot
 * mount the route and forget to register the pieces it reads at render time.
 * Registering also adds the `livechat` i18n namespace.
 */
export function createLivechatModule(host: LivechatHost): RouteObject {
    registerLivechatHost(host)
    return LivechatModule
}

export type { LivechatHost } from './host'
